import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-document-remove",
  "use": "icon-document-remove-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol viewBox=\"0 0 16 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-document-remove\">\n<path d=\"M13.7425 5.25L10.5 2.0075V5.25H13.7425ZM14.25 6.5H9.25V1.5H1.75V16.5H14.25V6.5ZM1.125 0.25H10.5L15.5 5.25V17.125C15.5 17.3075 15.4415 17.4573 15.3244 17.5744C15.2073 17.6915 15.0575 17.75 14.875 17.75H1.125C0.9425 17.75 0.792708 17.6915 0.675625 17.5744C0.558542 17.4573 0.5 17.3075 0.5 17.125V0.875C0.5 0.6925 0.558542 0.542708 0.675625 0.425625C0.792708 0.308542 0.9425 0.25 1.125 0.25ZM4.875 10.25H11.125V11.5H4.875V10.25Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/document-remove.svg
// module id = BYvc
// module chunks = 262